import {FC} from 'react';

const ExcelIcon: FC = () => {
  return (
    <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.264 17.929H2.32996V0.5H12.2361V4.41074H16.264V17.929Z"
        fill="#FCFCFC"
        stroke="#818181"
        stroke-miterlimit="10"
      />
      <path d="M16.2439 4.47396L12.2159 0.565907L12.441 0.296387L16.4905 4.19276L16.2439 4.47396Z" fill="#818181" />
      <path
        d="M8.50409 4.87695H0.957668C0.428762 4.87695 0 5.27918 0 5.77535V12.8548C0 13.3509 0.428762 13.7532 0.957668 13.7532H8.50409C9.033 13.7532 9.46176 13.3509 9.46176 12.8548V5.77535C9.46176 5.27918 9.033 4.87695 8.50409 4.87695Z"
        fill="#107C42"
      />
      <path d="M7.22706 12.2368H5.96629L2.23425 6.39355H3.5204L7.22706 12.2368Z" fill="white" />
      <path d="M2.23425 12.2368H3.49502L7.22706 6.39355H5.9409L2.23425 12.2368Z" fill="white" />
      <path d="M12.2355 7.146H9.9563V8.09426H12.2355V7.146Z" fill="#21A365" />
      <path d="M15.0526 7.146H12.7733V8.09426H15.0526V7.146Z" fill="#33C481" />
      <path d="M12.2355 8.5791H9.9563V9.52736H12.2355V8.5791Z" fill="#107C42" />
      <path d="M15.0526 8.5791H12.7733V9.52736H15.0526V8.5791Z" fill="#21A365" />
      <path d="M12.2355 10.0112H9.9563V10.9595H12.2355V10.0112Z" fill="#195D38" />
      <path d="M15.0526 10.0112H12.7733V10.9595H15.0526V10.0112Z" fill="#104B2B" />
    </svg>
  );
};

export default ExcelIcon;
